var _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _g6, _rect, _path4, _path5, _g7, _path6, _g8, _g9, _rect2, _path7, _path8, _path9, _path10, _rect3, _rect4, _path11, _path12, _g10, _path13, _g11, _path14, _rect5, _rect6, _rect7, _g12, _g13, _g14, _g15, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _g16, _g17, _rect30, _g18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "225px",
    viewBox: "0 0 300 225",
    enableBackground: "new 0 0 300 225",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.482,208.226l-3.009-3.009l3.009-3.008l3.008,3.008L44.482,208.226z M42.558,205.217l1.924,1.926 l1.926-1.926l-1.926-1.926L42.558,205.217z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M238.018,158.237l-3.009-3.008l3.009-3.009l3.009,3.009L238.018,158.237z M236.094,155.229l1.924,1.926 l1.926-1.926l-1.926-1.927L236.094,155.229z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25AFC6",
    d: "M10.958,44.476H6.375V41.77h4.583v-4.793h2.811v4.793h4.583v2.706h-4.583v4.792h-2.811V44.476z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52.538,126.853l-3.009-3.009l3.009-3.008l3.009,3.008L52.538,126.853z M50.614,123.844l1.924,1.926 l1.925-1.926l-1.925-1.926L50.614,123.844z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDE5E9",
    points: "141.166,161.974 84.559,185.323 24.413,165.023 24.413,66.575 84.329,86.796 141.166,63.349  201.195,88.113 201.195,186.736  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17C6E3",
    points: "84.442,181.796 27.717,162.653 27.717,71.18 84.442,90.326  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#19D3F2",
    points: "141.166,158.392 84.442,181.796 84.442,90.326 141.166,66.928  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17C6E3",
    points: "197.882,181.796 141.166,158.392 141.166,66.928 197.882,90.326  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0BF37",
    d: "M128.362,84.113c-0.308,0-0.584,0.369-0.826,0.617c-0.298,0.292-0.226,1.386-0.557,1.386 c0,5.313-7.532,9.826-7.532,12.762c0,1.017,0.367,2.049,0.367,3.065c0,3.222-3.012,5.069-3.012,7.871 c0,2.073,0.843,3.062,1.284,3.062c0.367,0,0.143,0.097,0.518,0.097c1.088,0,3.477-3.384,3.477-3.384s3.781-6.282,3.781-8.327 c0,0,0.924-1.441,0.924-2.565c0-0.244,1.735-5.304,1.857-5.629c0.355-2.235,1.206-4.471,1.206-6.792 C129.849,84.318,129.155,84.113,128.362,84.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7B03A",
    d: "M164.203,167.9l33.68,13.896v-58.893c-1.805,0.866-3.654,1.632-5.504,1.911 c-3.877,0.6-5.75-0.449-8.734,1.979c-1.385,1.132-2.314,1.749-3.08,3.502c-0.992,2.243-0.875,1.527,0.219,2.768 c2.094,2.327,4.348,1.314,3.387,4.892c-1.152,4.256-5.369,6.776-8.338,9.118c-1.799,1.415-2.07,3.34-3.219,5.199 c-1.18,1.927-2.965,3.628-4.596,5.188c-0.664,0.632-4.324,2.941-4.432,3.86c-0.236,2.232,2.111,0.949,2.537,2.11 C166.812,165.276,165.878,166.716,164.203,167.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A7B03A",
    d: "M197.882,111.977v-3.502c-8.621,1.396-17.088,3.46-25.291,6.219c-0.037,0.075-0.082,0.146-0.121,0.221 c-0.068-0.033-0.133-0.075-0.209-0.111c-10.879,3.682-21.293,8.554-31.096,14.447v13.732c0.459-0.496,0.908-1.031,1.393-1.597 c1.668-1.917,3.646-3.562,5.354-5.456c1.066-1.171,1.617-2.336,2.957-3.319c1.545-1.128,3.635-2.612,5.463-3.118 c2.219-0.601,4.574-0.156,6.803,0.1c2.299,0.263,3.678,0.243,5.338-0.407c-0.018,1.165,0.197,2.234,0.957,2.639 c0.904,0.483,3.289,0.607,4.307,0.374c1.242-0.271,2.133-1.115,3.275-1.307c0.746-0.122,1.898-0.232,2.65,0.109 c-0.059,0.624-0.445,0.986-0.826,1.35c-0.146,0.154-0.568,0.337-0.771,0.499c-0.334,0.276-0.445,0.659-0.832,0.921 c-0.602,0.42-1.41,0.459-1.955,0.487c-0.484,0.021-0.77-0.253-1.324-0.108c-0.387,0.092-0.73,0.442-1.076,0.555 c0.527,0.157,0.818,0.628,1.301,0.843c-0.205,1.421-3.189,1.102-4.35,1.265c-1.029,0.146-1.703,0.434-2.766,0.156 c-0.83-0.221-1.906-0.915-1.67,0.541c0.158,0.907,1.582,1.401,0.379,2.553c-0.879,0.834-2.338-0.692-2.998,0.887 c-0.223,0.524,0.145,0.918,0.104,1.401c-0.051,0.51-0.355,0.91-0.578,1.352c-0.479,0.912-1.338,1.775-1.002,2.861 c2.271,0.744,3.307,0.343,5.098-0.998c1.041-0.782,1.289-1.002,1.912-2.044c0.533-0.889,1.002-1.765,2.043-2.172 c3.309-1.303-1.652,4.531,2.311,3.334c2.125-0.652,3.418-2.713,4.293-4.724c1.184-2.685,3.283-4.745,5.736-6.446 c2.301-1.59,7.969-3.721,4.795-7.057c-1.717-1.805-5.025,0.279-6.902,1.1c-1.781,0.778-6.957,4.602-8.482,2.538 c2.018-2.43,5.375-2.827,8.17-3.574c2.121-0.564,3.305-2.138,5.723-2.173c1.549-0.023,4.355,0.083,4.656-2.086 c-1.934-1.491-3.402-0.337-5.469,0.26c-1.275,0.36-2.521,0.493-3.709,1.188c-1.146,0.676-3.396,2.263-4.801,2.325 c-3.293,0.163,0.24-4.269,0.957-5.258c0.5-0.697,2.789-3.474,3.967-2.642c0.816,0.582-0.307,1.867,0.037,2.62 c0.557,1.198,2.045,0.629,2.992,0.278c1.293-0.489,2.654-0.673,3.926-1.08c1.191-0.375,2.34-1.04,3.578-1.386 c1.191-0.329,2.512-0.733,3.623-1.223c0.564-0.245,1.369-0.585,2.133-0.969v-2.708c-1.324,0.012-2.678,0.39-3.965,0.841 c-1.543,0.544-4.49,2.353-6.037,1.597c1.623-1.653,3.197-1.798,5.24-2.414C194.767,113.204,196.31,112.538,197.882,111.977z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A7B03A",
    d: "M151.158,158.476c0.572-1.688,1.232-3.65,2.824-4.634c0.816-0.498,5.861-1.974,5.299-3.512 c-0.801-2.218-8.537,3.141-7.037-1.084c1.078-3.033,4.797-3.264,6.863-5.592c0.959-1.083,2.334-3.36,0.215-3.683 c-1.732-0.255-3.428,1.01-4.951,1.643c-1.688,0.703-2.721,1.621-4.139,2.727c-1.283,1.009-2.531,2.508-4.027,3.17 c-1.49,0.666-2.799-0.15-4.305,0.122c-0.248,0.044-0.488,0.149-0.734,0.237v10.521l8.482,3.504 C150.187,160.779,150.755,159.677,151.158,158.476z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#BDC55A",
    d: "M141.166,147.87c-1.393,0.485-2.764,1.521-3.928,2.269c-0.764,0.483-4.246,3.379-4.219,1.002 c0.01-0.888,1.404-2.166,1.941-2.756c1.344-1.479,2.984-2.764,4.594-3.946c0.607-0.447,1.123-0.931,1.611-1.456V129.25 c-19.568,11.77-36.646,27.715-49.729,47.015c0.295,0.86,0.606,1.544,0.839,2.298l48.89-20.171V147.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7B03A",
    d: "M65.14,172.38c0-0.091,0.027-0.193,0.098-0.328c-0.944,0-1.414-0.473-1.897-0.948h-2.359 c-0.989-0.49-1.236-1.99-2.312-1.99c-0.67,0-1.341,0.668-2.011,0.668c-2.122,0-0.297-3.411-3.734-3.411 c-0.942,0-0.942-1.898-2.365-1.898c0-0.944-0.465-1.415-1.416-1.887v-0.948c-0.388,0-0.757-0.607-1.131-0.607 c-0.104,0-0.199,0.04-0.287,0.137c0-1.657-2.572-1.554-5.21-3.316c0-0.911,1.546-3.214,0.65-3.214 c-0.182,0-0.182-0.185-0.182-0.396c0-0.296,0-0.653-0.469-0.653c0-1.746-0.888-6.628-2.374-6.628 c0.099-0.189,0.143-0.359,0.143-0.515c0-1.587-1.557-1.376-1.557-1.376c0-3.806-2.029-1.813-2.029-4.224 c0-0.085,0.017-0.177,0.049-0.272c-0.052-0.079-0.086-0.159-0.128-0.241c-0.393,0-0.728,0-0.728,0v-0.822 c-0.032-0.04-0.049-0.081-0.072-0.126H34.94c0.352-0.344,0.04-0.588-0.22-0.881c-0.009-0.006-0.023-0.006-0.045-0.006 c-0.343-0.058-0.646-0.226-0.902-0.459c-0.906-0.1-1.38-1.104-2.147-1.493c-1.416-0.472-1.894-1.894-2.84-3.312 c-0.592-1.484-0.738-4.183-1.068-5.979v35.399l43.475,14.669C68.158,174.141,65.14,172.38,65.14,172.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C350",
    d: "M84.442,136.937c0.331-0.103,0.659-0.211,1.035-0.318c0.615-0.616,3.877-3.87,4.76-3.87 c0.802,0,3.699-5.212,5.021-5.212c0.288,0,0.587-0.598,0.879-0.598c0.073,0,2.266-4.079,2.266-4.911 c0-0.413,0.422-0.832,0.838-0.832c1.687,0,4.762-1.805,4.762-7.22c0-1.045-0.07-2.1-0.07-3.15c0-5.723,7.609-7.459,9.478-12.145 c0.158-0.3,2.131-5.904,2.131-6.386c0-5.362-3.754-10.052-4.507-12.938l-26.592,10.97V136.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7B03A",
    d: "M27.717,76.036c1.242-0.338,3.305-0.7,3.564-0.7c0.408,0.417,0.836,0.417,1.25,0.417 c0.335,0.499,2.736,3.751,3.336,3.751c0.326,0,0.663-0.536,1.218-0.536c0.245,0,0.362,0.132,0.362-0.038 c0-0.227,0.591-0.295,0.591-0.521c0-0.834,6.52-3.044,6.52,3.038c0,2.965,1.317,5.932,1.317,8.897 c0.832,2.083,2.5,2.917,4.163,4.586c-0.044,0.089-0.063,0.174-0.063,0.249c0,0.52,0.966,0.648,0.966,1.163 c0,0.199,2.245,2.135,2.855,2.338c0.346,0,0.397,0.292,0.411,0.629c0.062,0.046,0.117,0.09,0.169,0.14 c0.026,0.017,0.034,0.046,0.054,0.067h1.025c0.424,0.416,0.424,0.838,0.836,0.838c-0.055,0.228-0.083,0.452-0.083,0.675 c0,1.145,0.189,1.856,0.416,2.318c0.281,0.156,0.507,0.381,0.669,0.639c0.477,0.363,0.796,0.865,0.843,1.461 c1.567,0.094-2.904,7.483-2.904,10.673c0,0.838,1.271,10.91,4.403,10.91c0.836,0.422,0.836,2.087,2.078,2.087 c3.395,10.17,3.463,7.149,7.508,9.167c0,0.84-0.098,2.923,0.836,2.923c1.254,0,2.5,0.108,3.745,0.108 c5.816,0,3.127-1.99,10.64-4.379V90.326L27.717,71.18V76.036z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M201.778,113.74c0,0.925-0.751,1.676-1.676,1.676h-4.812c-0.926,0-1.676-0.751-1.676-1.676V100.35 c0-0.926,0.75-1.675,1.676-1.675h4.812c0.925,0,1.676,0.749,1.676,1.675V113.74z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M201.778,93.654c0,0.923-0.751,1.674-1.676,1.674h-4.812c-0.926,0-1.676-0.751-1.676-1.674V80.261 c0-0.924,0.75-1.673,1.676-1.673h4.812c0.925,0,1.676,0.749,1.676,1.673V93.654z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M275.221,93.654c0,0.923-0.751,1.674-1.674,1.674h-4.812c-0.926,0-1.678-0.751-1.678-1.674V80.261 c0-0.924,0.752-1.673,1.678-1.673h4.812c0.923,0,1.674,0.749,1.674,1.673V93.654z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 195.238,
    y: 66.938,
    width: 78.303,
    height: 107.134
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible",
    fill: "#70C1B3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.996,
    y: 106.942,
    fill: "#D0602D",
    width: 87.551,
    height: 62.585
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.38,
    y: 31.785,
    fill: "#F2EFEB",
    width: 94.522,
    height: 150.518
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F2EFE4",
    points: "228.615,100.353 230.29,31.785 186.38,31.785 186.38,119.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B8C350",
    points: "224.58,85.882 224.58,31.785 186.38,31.785 186.38,103.811  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.38,
    y: 146.98,
    fill: "#E0CEA6",
    width: 46.547,
    height: 3.588
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 228.973,
    y: 165.974,
    fill: "#E0CEA6",
    width: 51.93,
    height: 3.586
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 212.645,
    y: 92.733,
    transform: "matrix(0.9101 -0.4144 0.4144 0.9101 -19.8387 99.0421)",
    fill: "#D6D3CA",
    width: 11.406,
    height: 5.022
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.623,
    y: 105.827,
    transform: "matrix(0.9102 -0.4142 0.4142 0.9102 -27.0513 90.1518)",
    fill: "#E6DDCA",
    width: 11.408,
    height: 3.235
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D6D3CA",
    points: "210.072,96.537 207.398,97.755 206.826,96.489 201.908,98.725 202.482,99.993 199.688,101.265  201.767,105.834 212.151,101.109  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F4B72B",
    points: "280.903,125.814 280.903,120.228 232.842,96.748 232.842,31.785 227.824,31.785 227.824,96.748  186.38,117.045 186.38,122.638 227.824,102.338 227.824,182.303 232.842,182.303 232.842,102.337  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 239.016,
    y: 112.726,
    fill: "#D6D3CA",
    width: 4.664,
    height: 8.608
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D6D3CA",
    points: "251.033,113.866 239.409,108.143 235.789,110.394 235.789,131.736 240.809,131.736  240.809,114.43 251.033,119.466  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.789,
    y: 134.965,
    fill: "#D6D3CA",
    width: 5.395,
    height: 11.354
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.789,
    y: 134.965,
    fill: "#D6D3CA",
    width: 10.043,
    height: 4.484
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6DDCA",
    points: "245.832,155.054 245.832,150.568 241.183,150.568 235.789,150.568 235.789,155.054  235.789,159.679 235.789,161.924 235.789,164.163 245.832,164.163 245.832,159.679 241.183,159.679 241.183,155.054  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.362,
    y: 151.098,
    fill: "#E6DDCA",
    width: 18.652,
    height: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.101,
    y: 158.376,
    fill: "#E6DDCA",
    width: 18.654,
    height: 5.738
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.253,
    y: 153.968,
    fill: "#E6DDCA",
    width: 9.323,
    height: 6.466
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B8C350",
    points: "280.903,128.477 253.362,114.513 253.362,148.773 280.903,148.773  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.68,
    y: 123.904,
    fill: "#B8C350",
    width: 19.012,
    height: 7.738
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.939,
    y: 134.965,
    fill: "#B8C350",
    width: 11.478,
    height: 13.809
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.005,
    y: 112.726,
    fill: "#D6D3CA",
    width: 4.574,
    height: 13.374
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.005,
    y: 128.383,
    fill: "#D6D3CA",
    width: 4.574,
    height: 15.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.446,
    y: 133.009,
    fill: "#D6D3CA",
    width: 7.849,
    height: 6.636
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.118,
    y: 134.578,
    fill: "#D6D3CA",
    width: 13.99,
    height: 3.496
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6DDCA",
    points: "192.927,129.107 190.407,123.951 214.401,112.204 216.921,117.362  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 189.874,
    y: 133.009,
    fill: "#E6DDCA",
    width: 6.098,
    height: 11.259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.853,
    y: 31.785,
    fill: "#D6D3CA",
    width: 7.258,
    height: 28.793
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.54,
    y: 31.785,
    fill: "#D6D3CA",
    width: 2.995,
    height: 28.793
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.41,
    y: 31.785,
    fill: "#B8C350",
    width: 2.998,
    height: 28.793
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.41,
    y: 63.966,
    fill: "#B8C350",
    width: 2.998,
    height: 13.013
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.853,
    y: 65.109,
    fill: "#D6D3CA",
    width: 4.92,
    height: 28.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.111,
    y: 67.127,
    fill: "#E6DDCA",
    width: 3.828,
    height: 8.681
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.111,
    y: 77.895,
    fill: "#E6DDCA",
    width: 3.828,
    height: 6.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.451,
    y: 98.437,
    fill: "#D6D3CA",
    width: 4.972,
    height: 14.918
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.178,
    y: 100.625,
    transform: "matrix(0.8959 0.4443 -0.4443 0.8959 72.7168 -104.3647)",
    fill: "#D6D3CA",
    width: 15.721,
    height: 4.692
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C350",
    d: "M261.253,75.91c0,8.7,5.748,16.354,14.104,18.78l5.545,1.61V31.786h-19.648V75.91z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.874,
    y: 154.35,
    fill: "#D6D3CA",
    width: 4.453,
    height: 22.982
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.126,
    y: 154.781,
    fill: "#D6D3CA",
    width: 24.168,
    height: 5.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.126,
    y: 163.479,
    fill: "#E6DDCA",
    width: 7.793,
    height: 3.588
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.443,
    y: 163.479,
    fill: "#E6DDCA",
    width: 3.589,
    height: 3.588
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.652,
    y: 163.479,
    fill: "#E6DDCA",
    width: 3.588,
    height: 3.588
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.86,
    y: 163.479,
    fill: "#E6DDCA",
    width: 3.587,
    height: 3.588
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E6DDCA",
    cx: 210.673,
    cy: 127.366,
    r: 3.594
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C350",
    d: "M222.294,174.243c0,2.112-1.713,3.826-3.828,3.826h-16.168c-2.111,0-3.824-1.714-3.824-3.826l0,0 c0-2.115,1.713-3.827,3.824-3.827h16.168C220.582,170.416,222.294,172.128,222.294,174.243L222.294,174.243z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.789,
    y: 171.854,
    fill: "#B8C350",
    width: 42.565,
    height: 2.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.789,
    y: 176.156,
    fill: "#D6D3CA",
    width: 42.565,
    height: 4.306
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 261.744,
    y: 92.912,
    transform: "matrix(0.7104 0.7038 -0.7038 0.7104 144.6239 -159.6746)",
    fill: "#D6D3CA",
    width: 9.214,
    height: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.648,
    y: 85.086,
    transform: "matrix(0.401 0.9161 -0.9161 0.401 236.7915 -185.9742)",
    fill: "#D6D3CA",
    width: 5.922,
    height: 6
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D6D3CA",
    points: "237.853,90.232 237.853,95.129 248.971,100.696 251.056,96.494  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.118,
    y: 134.578,
    fill: "#D6D3CA",
    width: 5.264,
    height: 9.689
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B96BF",
    d: "M210.872,75.44c0,3.565-2.886,6.454-6.451,6.454l0,0c-3.565,0-6.455-2.889-6.455-6.454V46.001 c0-3.565,2.89-6.455,6.455-6.455l0,0c3.565,0,6.451,2.89,6.451,6.455V75.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0602D",
    d: "M240.09,139.766c-2.47,0-4.468,2.002-4.468,4.469c0,2.468,4.468,10.584,4.468,10.584 s4.468-8.116,4.468-10.584C244.558,141.768,242.556,139.766,240.09,139.766z M240.09,146.038c-1.209,0-2.186-0.98-2.186-2.187 c0-1.208,0.977-2.186,2.186-2.186c1.207,0,2.188,0.978,2.188,2.186C242.279,145.058,241.297,146.038,240.09,146.038z"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 195.238,
    y: 66.938,
    fill: "#70C1B3",
    width: 78.303,
    height: 16.99
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M264.313,44.62h-59.848c-5.095,0-9.228,4.122-9.228,9.206v13.113h78.303V53.825 C273.541,48.742,269.41,44.62,264.313,44.62z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M264.313,196.391h-59.848c-5.095,0-9.228-4.121-9.228-9.205v-13.113h78.303v13.113 C273.541,192.27,269.41,196.391,264.313,196.391z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDE9E0",
    d: "M234.39,189.974c-3.308,0-5.999-2.689-5.999-5.999c0-3.306,2.691-5.995,5.999-5.995 s5.997,2.689,5.997,5.995C240.387,187.284,237.698,189.974,234.39,189.974z M234.39,179.651c-2.384,0-4.327,1.94-4.327,4.323 c0,2.386,1.943,4.325,4.327,4.325c2.385,0,4.323-1.939,4.323-4.325C238.713,181.592,236.775,179.651,234.39,179.651z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDE9E0",
    d: "M248.548,56.06c0,0.77-0.625,1.395-1.395,1.395h-25.529c-0.771,0-1.393-0.625-1.393-1.395l0,0 c0-0.768,0.621-1.394,1.393-1.394h25.529C247.923,54.667,248.548,55.292,248.548,56.06L248.548,56.06z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "206.918,78.809 202.463,74.805 206.918,70.801 207.586,71.545 203.959,74.805 207.586,78.064  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "263.837,72.613 264.648,74.254 266.458,74.518 265.149,75.794 265.457,77.596 263.837,76.745  262.218,77.596 262.53,75.794 261.22,74.518 263.031,74.254  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M257.7,77.118l-1.297-1.354c0.232-0.309,0.374-0.685,0.374-1.1c0-1.012-0.821-1.833-1.834-1.833 c-1.01,0-1.835,0.821-1.835,1.833c0,1.012,0.825,1.835,1.835,1.835c0.381,0,0.735-0.118,1.029-0.317l1.29,1.354 c0.06,0.062,0.139,0.093,0.218,0.093c0.077,0,0.149-0.028,0.207-0.084C257.808,77.43,257.813,77.24,257.7,77.118z M253.711,74.663 c0-0.678,0.553-1.234,1.231-1.234c0.68,0,1.232,0.556,1.232,1.234c0,0.679-0.553,1.231-1.232,1.231 C254.264,75.895,253.711,75.342,253.711,74.663z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 195.238,
    y: 83.327,
    fill: "#538F84",
    width: 78.303,
    height: 0.602
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#E6DDCA",
    d: "M220.818,44.62h-21.164c-5.095,0-9.228,4.122-9.228,9.207v13.112V78.6 c-0.9,0.03-1.623,0.757-1.623,1.662v13.392c0,0.904,0.723,1.633,1.623,1.664v3.369c-0.9,0.029-1.623,0.757-1.623,1.663v13.391 c0,0.906,0.723,1.634,1.623,1.664v58.668v13.113c0,5.084,4.133,9.205,9.228,9.205h21.164V44.62z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105.708,101.376c0,1.359-1.099,2.457-2.454,2.457h-7.065c-1.356,0-2.457-1.098-2.457-2.457V81.721 c0-1.358,1.101-2.46,2.457-2.46h7.065c1.355,0,2.454,1.102,2.454,2.46V101.376z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105.708,71.892c0,1.356-1.099,2.455-2.454,2.455h-7.065c-1.356,0-2.457-1.099-2.457-2.455V52.235 c0-1.358,1.101-2.458,2.457-2.458h7.065c1.355,0,2.454,1.1,2.454,2.458V71.892z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M213.514,71.892c0,1.356-1.099,2.455-2.455,2.455h-7.062c-1.36,0-2.458-1.099-2.458-2.455V52.235 c0-1.358,1.098-2.458,2.458-2.458h7.062c1.356,0,2.455,1.1,2.455,2.458V71.892z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.111,
    y: 32.677,
    fill: "#14ADB4",
    width: 114.941,
    height: 157.261
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96.111,
    y: 32.677,
    fill: "#06B9CE",
    width: 114.941,
    height: 24.941
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M197.504-0.083h-87.847c-7.479,0-13.547,6.049-13.547,13.513v19.247h114.941V13.43 C211.052,5.966,204.988-0.083,197.504-0.083z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M197.504,222.699h-87.847c-7.479,0-13.547-6.056-13.547-13.517v-19.245h114.941v19.245 C211.052,216.644,204.988,222.699,197.504,222.699z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDE9E0",
    d: "M153.583,213.279c-4.858,0-8.806-3.949-8.806-8.805s3.947-8.806,8.806-8.806 c4.852,0,8.805,3.95,8.805,8.806S158.435,213.279,153.583,213.279z M153.583,198.126c-3.498,0-6.35,2.848-6.35,6.349 c0,3.498,2.852,6.349,6.35,6.349c3.499,0,6.346-2.851,6.346-6.349C159.929,200.974,157.083,198.126,153.583,198.126z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDE9E0",
    d: "M174.364,16.709c0,1.132-0.915,2.048-2.042,2.048h-37.477c-1.13,0-2.045-0.916-2.045-2.048l0,0 c0-1.128,0.915-2.043,2.045-2.043h37.477C173.449,14.666,174.364,15.581,174.364,16.709L174.364,16.709z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "196.809,41.009 198,43.417 200.654,43.802 198.731,45.674 199.183,48.324 196.809,47.073  194.431,48.324 194.886,45.674 192.96,43.802 195.624,43.417  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M187.796,47.622l-1.9-1.991c0.336-0.451,0.549-1.007,0.549-1.613c0-1.485-1.209-2.695-2.695-2.695 c-1.48,0-2.691,1.209-2.691,2.695c0,1.482,1.211,2.691,2.691,2.691c0.561,0,1.078-0.17,1.512-0.462l1.894,1.984 c0.089,0.093,0.204,0.137,0.319,0.137c0.109,0,0.221-0.04,0.308-0.124C187.957,48.078,187.967,47.798,187.796,47.622z  M181.943,44.018c0-0.999,0.812-1.812,1.807-1.812c1.002,0,1.809,0.812,1.809,1.812c0,0.995-0.807,1.808-1.809,1.808 C182.755,45.826,181.943,45.013,181.943,44.018z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFF2E8",
    d: "M211.052,159.194v-3.695h-21.287v-42.344h21.287v-3.695h-21.287V57.175h-3.693v52.285h-28.609V57.175h-3.696 v52.285H125.16V57.175h-3.695v52.285H96.111v3.695h25.354v42.344H96.111v3.695h25.354v30.743h3.695v-30.743h28.606v30.743h3.696 v-30.743h28.609v30.743h3.693v-30.743H211.052z M153.766,155.499H125.16v-42.344h28.606V155.499z M186.072,155.499h-28.609v-42.344 h28.609V155.499z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 96.111,
    y: 56.734,
    fill: "#05A0B3",
    width: 114.941,
    height: 0.884
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 128.623,
    y: 117.869,
    fill: "#18CCD4",
    width: 4.846,
    height: 11.313
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 128.623,
    y: 131.637,
    fill: "#18CCD4",
    width: 4.846,
    height: 18.091
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.623,
    y: 63.01,
    fill: "#18CCD4",
    width: 4.846,
    height: 11.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.623,
    y: 77.322,
    fill: "#18CCD4",
    width: 4.846,
    height: 11.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.623,
    y: 91.547,
    fill: "#18CCD4",
    width: 4.846,
    height: 11.313
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 145.524,
    y: 63.01,
    fill: "#18CCD4",
    width: 4.85,
    height: 11.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.524,
    y: 77.322,
    fill: "#18CCD4",
    width: 4.85,
    height: 11.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.524,
    y: 91.547,
    fill: "#18CCD4",
    width: 4.85,
    height: 11.313
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 161.173,
    y: 63.01,
    fill: "#18CCD4",
    width: 4.85,
    height: 11.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.173,
    y: 77.322,
    fill: "#18CCD4",
    width: 4.85,
    height: 11.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.173,
    y: 91.547,
    fill: "#18CCD4",
    width: 4.85,
    height: 11.313
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 178.079,
    y: 63.01,
    fill: "#18CCD4",
    width: 4.849,
    height: 11.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.079,
    y: 77.322,
    fill: "#18CCD4",
    width: 4.849,
    height: 11.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.079,
    y: 91.547,
    fill: "#18CCD4",
    width: 4.849,
    height: 11.313
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 143.169,
    y: 117.869,
    fill: "#18CCD4",
    width: 4.85,
    height: 23.779
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 161.177,
    y: 118.622,
    fill: "#18CCD4",
    width: 4.848,
    height: 26.027
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 176.413,
    y: 118.622,
    fill: "#18CCD4",
    width: 4.85,
    height: 26.027
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 193.035,
    y: 117.4,
    fill: "#18CCD4",
    width: 4.85,
    height: 33.944
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 201.54,
    y: 117.4,
    fill: "#18CCD4",
    width: 4.845,
    height: 33.944
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 101.877,
    y: 117.4,
    fill: "#18CCD4",
    width: 4.846,
    height: 33.944
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 110.378,
    y: 117.4,
    fill: "#18CCD4",
    width: 4.85,
    height: 33.944
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 101.877,
    y: 163.288,
    fill: "#18CCD4",
    width: 4.846,
    height: 22.169
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 110.378,
    y: 163.288,
    fill: "#18CCD4",
    width: 4.85,
    height: 22.169
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 101.877,
    y: 63.01,
    fill: "#18CCD4",
    width: 4.846,
    height: 40.809
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 110.378,
    y: 63.01,
    fill: "#18CCD4",
    width: 4.85,
    height: 40.809
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 194.386,
    y: 63.01,
    fill: "#18CCD4",
    width: 4.848,
    height: 40.809
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 176.413,
    y: 125.488,
    fill: "#18CCD4",
    width: 4.85,
    height: 26.025
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 128.623,
    y: 144.649,
    fill: "#18CCD4",
    width: 19.328,
    height: 6.695
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 128.623,
    y: 163.581,
    fill: "#18CCD4",
    width: 19.328,
    height: 6.692
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 128.623,
    y: 173.737,
    fill: "#18CCD4",
    width: 19.328,
    height: 6.696
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 162.388,
    y: 163.581,
    fill: "#18CCD4",
    width: 19.326,
    height: 6.692
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 162.388,
    y: 173.737,
    fill: "#18CCD4",
    width: 19.326,
    height: 6.696
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 194.297,
    y: 163.581,
    fill: "#18CCD4",
    width: 11.674,
    height: 6.692
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 194.297,
    y: 173.737,
    fill: "#18CCD4",
    width: 11.674,
    height: 6.696
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 164.867,
    y: 125.488,
    fill: "#18CCD4",
    width: 16.396,
    height: 4.848
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 164.867,
    y: 136.076,
    fill: "#18CCD4",
    width: 16.396,
    height: 4.848
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42566B",
    d: "M139.875,68.049c-4.461,0-8.072,3.619-8.072,8.074c0,4.461,8.072,19.121,8.072,19.121 s8.076-14.66,8.076-19.121C147.951,71.668,144.333,68.049,139.875,68.049z M139.875,79.381c-2.18,0-3.951-1.77-3.951-3.948 c0-2.184,1.771-3.952,3.951-3.952c2.182,0,3.954,1.768,3.954,3.952C143.829,77.611,142.056,79.381,139.875,79.381z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42566B",
    d: "M173.064,141.648c-4.459,0-8.071,3.615-8.071,8.071c0,4.462,8.071,19.123,8.071,19.123 s8.074-14.661,8.074-19.123C181.138,145.264,177.522,141.648,173.064,141.648z M173.064,152.979c-2.182,0-3.949-1.768-3.949-3.95 c0-2.18,1.768-3.95,3.949-3.95s3.948,1.771,3.948,3.95C177.012,151.211,175.246,152.979,173.064,152.979z"
  }))), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 194.386,
    y: 97.204,
    fill: "#18CCD4",
    width: 13.139,
    height: 6.615
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.376,
    y: 97.204,
    fill: "#42566B",
    width: 1,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42566B",
    d: "M140.376,109.376h-1v-1.862h1V109.376z M140.376,106.583h-1v-1.862h1V106.583z M140.376,103.79h-1v-1.862 h1V103.79z M140.376,100.997h-1v-1.862h1V100.997z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#42566B",
    points: "140.876,111.808 139.376,111.808 139.376,110.308 140.376,110.308 140.376,110.808  140.876,110.808  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42566B",
    d: "M153.575,111.808h-2.116v-1h2.116V111.808z M150.4,111.808h-2.116v-1h2.116V111.808z M147.226,111.808 h-2.116v-1h2.116V111.808z M144.051,111.808h-2.116v-1h2.116V111.808z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#42566B",
    points: "156.132,112.308 155.132,112.308 155.132,111.808 154.632,111.808 154.632,110.808  156.132,110.808  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42566B",
    d: "M156.132,155.548h-1v-2.059h1V155.548z M156.132,152.46h-1v-2.06h1V152.46z M156.132,149.371h-1v-2.06h1 V149.371z M156.132,146.282h-1v-2.059h1V146.282z M156.132,143.193h-1v-2.059h1V143.193z M156.132,140.105h-1v-2.06h1V140.105z  M156.132,137.017h-1v-2.06h1V137.017z M156.132,133.928h-1v-2.059h1V133.928z M156.132,130.839h-1v-2.059h1V130.839z  M156.132,127.751h-1v-2.06h1V127.751z M156.132,124.662h-1v-2.06h1V124.662z M156.132,121.573h-1v-2.059h1V121.573z  M156.132,118.484h-1v-2.059h1V118.484z M156.132,115.396h-1v-2.06h1V115.396z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#42566B",
    points: "156.632,158.078 155.132,158.078 155.132,156.578 156.132,156.578 156.132,157.078  156.632,157.078  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42566B",
    d: "M161.747,158.078h-1.705v-1h1.705V158.078z M159.189,158.078h-1.704v-1h1.704V158.078z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#42566B",
    points: "164.098,158.578 163.098,158.578 163.098,158.078 162.598,158.078 162.598,157.078  164.098,157.078  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42566B",
    d: "M164.098,170.798h-1v-2.037h1V170.798z M164.098,167.743h-1v-2.037h1V167.743z M164.098,164.688h-1v-2.036 h1V164.688z M164.098,161.633h-1v-2.036h1V161.633z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#42566B",
    points: "164.598,173.315 163.098,173.315 163.098,171.815 164.098,171.815 164.098,172.315  164.598,172.315  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42566B",
    d: "M170.998,173.315h-2.134v-1h2.134V173.315z M167.797,173.315h-2.133v-1h2.133V173.315z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 172.064,
    y: 172.315,
    fill: "#42566B",
    width: 1,
    height: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppImg);
export default __webpack_public_path__ + "static/media/app_img.91d8ff4142a9815ec4221557606cae84.svg";
export { ForwardRef as ReactComponent };